import React from 'react';

import configFR from '../config/FR';
import configGB from '../config/GB';
import configINT from '../config/INT';
import configUS from '../config/US';

import type {
  LocalisationConfig,
  LocalisationConfigWithLang,
  LocalisationConfigEntry,
  LocalisationConfigValue,
  LocalisationConfigContextType,
} from '../types';

let config: LocalisationConfig = {};

export function resolveConfigLanguage(newConfig: LocalisationConfigWithLang, language: string) {
  const langResolvedConfig = { ...newConfig } as LocalisationConfig;

  Object.entries(langResolvedConfig).forEach(([key, value]) => {
    const resolvedValue = typeof value === 'object' ? value[language] ?? value.en : value;

    langResolvedConfig[key as LocalisationConfigEntry] = resolvedValue;
  });

  return langResolvedConfig;
}

export function setconfigByCountry(country: string, language: string) {
  let newConfig: LocalisationConfigWithLang;

  switch (country) {
    case 'FR':
      newConfig = configFR;
      break;
    case 'GB':
      newConfig = configGB;
      break;
    case 'US':
      newConfig = configUS;
      break;
    default:
      newConfig = configINT;
      break;
  }
  const langResolvedConfig = resolveConfigLanguage(newConfig, language);

  config = langResolvedConfig as LocalisationConfig;

  return config;
}

export function getConfig(): LocalisationConfig {
  return config;
}

interface PerRequestCache {
  current: LocalisationConfigContextType | null;
}

let cache: (() => PerRequestCache) | null = null;

const getCache = () => {
  if (!cache) {
    cache = React.cache((): PerRequestCache => ({ current: null }));
  }
  return cache();
};

export function getLocalisationConfigServerContext() {
  return getCache().current;
}

export function setLocalisationConfigServerContext(context: LocalisationConfigContextType) {
  getCache().current = context;
}

export function createLocalisationConfigContext(configuration: LocalisationConfig) {
  const context: LocalisationConfigContextType = {
    configuration,
    getLocalisationConfig: (name: LocalisationConfigEntry) =>
      configuration[name] as LocalisationConfigValue,
  };

  return context;
}
